import * as React from 'react';

import { Color, IconName } from '../../enums';
import { Icon } from '../icon/icon.component';

import { Author, Container, Description, DescriptionContainer, LikeIconContainer } from './addToFavouriteBadge.styled';
import { AddToFavouriteBadgeProps } from './addToFavouriteBadge.types';

export const AddToFavouriteBadge: React.FC<AddToFavouriteBadgeProps> = (props: AddToFavouriteBadgeProps) => {
  const { author, description, isSelected = false, onClick, className }: AddToFavouriteBadgeProps = props;

  return (
    <Container className={className}>
      <LikeIconContainer onClick={onClick}>
        <Icon
          name={isSelected ? IconName.FavouriteFilled : IconName.Favourite}
          color={Color.White}
          size={20}
        />
      </LikeIconContainer>
      <DescriptionContainer>
        <Author>{author}</Author>
        <Description>{description}</Description>
      </DescriptionContainer>
    </Container>
  );
};
